"use strict";
/*
 * Created on 01 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var SelloutReleaseType_1 = require("../../release/model/sellout/SelloutReleaseType");

var SelloutDescription_1 = require("./SelloutDescription");

var SelloutSubSettings_1 = require("./SelloutSubSettings");
/**
 * @author Jaroslav Sevcik
 */


var SelloutSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutSettings, _DomainObject_1$Domai);

  function SelloutSettings(id, selloutType, priceListTypeId, description, settings) {
    var _this;

    _classCallCheck(this, SelloutSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutSettings).call(this));
    _this.id = id;
    _this.selloutType = selloutType;
    _this.priceListTypeId = priceListTypeId;
    _this.description = description;
    _this.settings = settings;
    return _this;
  }

  return SelloutSettings;
}(DomainObject_1.DomainObject);

exports.SelloutSettings = SelloutSettings;

SelloutSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutSettings.name);
  return {
    id: builder.id('id'),
    selloutType: builder.senum('selloutType', SelloutReleaseType_1.SelloutReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutReleaseType),
    priceListTypeId: builder.str('priceListTypeId'),
    description: builder.obj('description', SelloutDescription_1.SelloutDescription.schema, function (mat) {
      return new SelloutDescription_1.SelloutDescription(mat.basic, mat.identification, mat.priceCalculation, mat.responsibilities, mat.releaseTypes, mat.workflowTypes, mat.targetCondition, mat.endingOfValidity, mat.notification);
    }),
    settings: builder.opt(builder.obj('settings', SelloutSubSettings_1.SelloutSubSettings.schema, function (mat) {
      return new SelloutSubSettings_1.SelloutSubSettings(mat.remodelingDaysBeforeClosure, mat.categoryDiscounts);
    }))
  };
}();